/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { ReduxUtils } from '@spm/core';

import { POST_SD_UPLOAD_DOCUMENT } from './actionTypes';

import { postSdUploadDocumentUtil } from './utils';

/**
 * Contains the action creator functions that update the SDFiles slice of the store.
 *
 * @namespace SDFilesActions
 */
export default class actions {
  /**
   * Calls the api and dispatches the results to the store.
   * api: /v1/ua/sd_upload_document
   *
   * @param {NewSPMFileUploadContents} data object that will be posted to the api
   * @param {function} callback function to call once this function has finished
   * @function
   * @memberof SDFilesActions
   */
  static postSdUploadDocument = (dispatch, newSPMFileUploadContents, callback) => {
    ReduxUtils.generateAction(
      dispatch,
      postSdUploadDocumentUtil.bind(null, newSPMFileUploadContents),
      POST_SD_UPLOAD_DOCUMENT,
      callback
    );
  };

  /**
   * Dispatches the data to the store to reset the data cached from a call to postSdUploadDocument.
   *
   * @param {function} dispatch
   * @param {Object} data object to be set in the store.
   * @function
   * @memberof SDFilesActions
   */
  static resetPostSdUploadDocument = (dispatch, data) => {
    const json = {
      type: POST_SD_UPLOAD_DOCUMENT.successAction,
      payload: data,
    };
    dispatch(json);
  };

  /**
   * Dispatches the data to the store to reset the error cached from a call to postSdUploadDocument.
   *
   * @param {function} dispatch
   * @function
   * @memberof SDFilesActions
   */
  static resetPostSdUploadDocumentError = dispatch => {
    ReduxUtils.resetErrorAction(dispatch, POST_SD_UPLOAD_DOCUMENT.failureAction);
  };
}
